import React, { useState } from 'react';
import styles from './review.module.scss';
import { Col, Row } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import { sendOfferToCandidate, getPresignedUrlToUploadOfferLetter,uploadOfferLetterToS3} from '../../../../../services/util/offerHandling';
import { CustomButton } from '../../../../shared/customButton';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Review = (props) => {
    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };

    var file = new Blob([props.values.offerLetter[0]], { type: 'application/pdf' });
    let fileURL = URL.createObjectURL(file);
    const [offerLetterObject, setCVObject] = useState({ url: fileURL })

    let [isUploadLoading, setUploadLoading] = useState(false);

    // const submitDetails = async () => {
    //     setState(true)
    //     //time
    //     let dateTime = moment(props.values.shedule_date).format("YYYY-MM-DD HH:mm");
    //     //timeZone
    //     let timeZone = await props.timeZone.value;
    //     //reviewers
    //     let interviewersArray = [];
    //     await (props.interviewers).forEach(element => {
    //         interviewersArray.push(element._id)
    //     });
    //     let respond = await ReSheduleInterview(props.values.id, dateTime, timeZone, interviewersArray, props.values.interview_type, props.values.interview_location_address, props.values.guidelineDescription);
    //     if (respond.success === true) {
    //         setState(false)
    //         props.previousPage(1)
    //         props.handleClose()
    //         props.getAllSheduledInterviewValues()
    //     } else {
    //         setState(false)
    //     }
    // }

    //on submit function
    const submitDetails = async () => {

        //start loading
        setUploadLoading(true);

        let presignedURL = await getPresignedUrlToUploadOfferLetter(props.offerSessionDetails.offerSessionId);
        if (presignedURL.success === true){
            let respond = await uploadOfferLetterToS3(presignedURL.data.presigned_url, props.values.offerLetter[0]);
            if (respond.status === 200) {
                let data = {
                    offer_session_id :props.offerSessionDetails.offerSessionId
                }
                let sendOfferLetterRespond = await sendOfferToCandidate(data);
                if (sendOfferLetterRespond.success === true) {
                    setUploadLoading(false);
                    props.handleClose();
                    props.refreshData();
                } else {
                    setUploadLoading(false);
                }

            }else{
                setUploadLoading(false);
            }
        }else{
            setUploadLoading(false);
        }
    }

    return (
        <div>
            <Col>

                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Offer&nbsp;Letter&nbsp;:</span>
                        <div className={styles.imageContainer}>
                            <Document
                                file={offerLetterObject}
                                options={options}
                            >
                                <Page pageNumber={1} scale={0.24} />
                            </Document>
                        </div>
                    </Col>
                </Row>


            </Col>
            <div className="mt-5">
                <Row>
                    <Col>
                        <CustomButton
                            buttonType="submit"
                            label="Back"
                            type="defaultBtn"
                            handleClick={() => props.previousPage(1)}
                            disabled={isUploadLoading  ? true : false}
                        />
                    </Col>
                    <Col>
                        <CustomButton
                            buttonType="submit"
                            label="Submit"
                            type="primaryBtn"
                            backicon={
                                isUploadLoading ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    : ''
                            }
                            disabled={isUploadLoading ? true : false}
                            handleClick={() => submitDetails()}
                        />
                    </Col>
                </Row>
            </div>

        </div>
    )
}

export default Review;
